import React from 'react';

const ServiceContentTab = ({ serviceForm, setServiceForm }) => (
  <div className="space-y-4">
    <div className="bg-yellow-50 p-3 rounded-lg text-sm">
      <strong>Формат ссылок:</strong> [текст ссылки](/services/slug-услуги)
      <br />
      <span className="text-gray-600">Пример: [нотификация ФСБ](/services/notifikaciya)</span>
    </div>
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">Полное описание (RU)</label>
      <textarea
        value={serviceForm.full_content_ru}
        onChange={(e) => setServiceForm({ ...serviceForm, full_content_ru: e.target.value })}
        rows={10}
        placeholder="Поддерживает **жирный текст** и [ссылки](/services/slug)"
        className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-orange-500 font-mono text-sm"
        data-testid="service-full-content-ru"
      />
    </div>
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">Полное описание (EN)</label>
      <textarea
        value={serviceForm.full_content_en}
        onChange={(e) => setServiceForm({ ...serviceForm, full_content_en: e.target.value })}
        rows={6}
        className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-orange-500 font-mono text-sm"
        data-testid="service-full-content-en"
      />
    </div>
  </div>
);

export default ServiceContentTab;
